import actions from '../../actionTypes';

export default (id, startDate = new Date(), endDate = new Date()) => {
  return {
    type: actions.GET_HISTORY,
    id,
    startDate,
    endDate
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/getHistory.js